import { render, staticRenderFns } from "./confirmation-dialog.vue?vue&type=template&id=d8be4632&"
import script from "./confirmation-dialog.vue?vue&type=script&lang=js&"
export * from "./confirmation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports